

import { NodeInterface } from '@swivl-mono/types';
import { Dropdown, SelectableOption } from '@swivl-mono/ui';

import { SMSGroupModel } from '../../../../../Models/SMSGroup/SMSGroup.Model';
import TabNodeLayoutData from '../../NodeLayouts/TabNodeLayoutData';
import InspectorFooter from '../../SidePanel/Inspector/components/InspectorFooter';
import InspectorNodeHeader from '../../SidePanel/Inspector/components/InspectorNodeHeader';
import NodePanel from '../NodePanel'
import _ from "lodash"


import "./SMSGroup.Node.scss"
import { RandomId } from '@swivl-mono/helpers';



const SMSGroupSelect =  (props:any) => {
  const {node, deleteGroup, onChange} = props;  
  const {intervalGroups, campaignGroups} = SMSGroupModel.useState(s => ( {
    campaignGroups: s.campaignGroups,
    intervalGroups: s.intervalGroups,
  }));
  let options:SelectableOption[] = []
  if (node.action === "remove") {
    options.push({value:"REMOVE_FROM_ALL_GROUPS", label:"Remove From All" })

  }
  if (intervalGroups || campaignGroups ) {

      // for (let i = 0; i < groups.length; i++) {
      //     if (groups[i].type == "interval") {
      //         intervalGroups.push(groups[i])
      //     } else {
      //         campaignGroups.push(groups[i])
      //     }
      // }
      if (campaignGroups && campaignGroups.length) {
          options.push({isHeading:true, value:"campaignGroups", label:"Campaign Groups" })
          campaignGroups.forEach((item) => options.push({value:item.slug,  label:item.name }))
      } 
      if (intervalGroups && intervalGroups.length) {
          options.push({isHeading:true,  value:"IntervalHeading", label:"Interval Groups" })
          intervalGroups.forEach((item) => options.push({value:item.slug, label:item.name }))
      } 
  } else {
      options.push({isSpinner:true,  label:"Loading" })
  }
  options?.sort((a, b) => a.label.localeCompare(b.label))

  const groupViews = node.groups.map( (item, index) => {
      return  <div key={item.id} className="SMSGroupSelect"><div className="content">
        <Dropdown 
          showSearch={true}
          options={options} 
          value={item.groupSlug} 
          onChange={onChange} 
          name={"groups." + index + ".groupSlug"} 
          />
              <div className="removeButtonRow">

        <span className="deleteButtonIcon logicDelete" onClick={() => { deleteGroup("groups", index)}}>REMOVE</span>
        </div>    
      </div></div>
  })

  return (
      <div >
         {groupViews}
      </div>
    );
 }

const SMSGroup = {
  Type: "SMSGroup",
  Empty: function() {
          let node = {
              "id": RandomId(6),
              "type": SMSGroup.Type,
              "text": "",
              "goto":"",
              "noPhoneNumberGoto":"",
              "invalidPhoneNumberGoto":"",
              "action": "add",
              "groups":[] 
            }

        return node; //

    },
    PlumbData: function(node:NodeInterface) {


      const tabs = [{
         "id": "gotoSMSGroup",
         "source": "goto",
         "target": node.goto,
         "title": (node.action === "add") ? "Added" : "Removed",
       },
       {
          "id": "noPhoneNumberGoto",
          "source": "noPhoneNumberGoto",
          "target": node.noPhoneNumberGoto,
          "title": "No Phone #",
        },
        {
          "id": "invalidPhoneNumberGoto",
          "source": "invalidPhoneNumberGoto",
          "target": node.invalidPhoneNumberGoto,
          "title": "Invalid #",
        }

     ]
     const displayText = node.text.length > 23 ? node.text.substring(0,20) + "..." : node.text;

     return TabNodeLayoutData({
      node: node,
      title: "SMS Group" ,
      body: displayText,
      baseWidth: 180,
      tabs:tabs
    });

   },
   InspectorPanel: class InputInspectorPanel extends NodePanel{
     constructor(props:any) {       super(props);
       this.changeAction = this.changeAction.bind(this)
       this.addGroup    = this.addGroup.bind(this)
    //    this.addGroup    = this.addGroup.bind(this)

    
       
       SMSGroupModel.loadGroups(false); 
     }

     changeAction(event:any) {
      const target = event.target;
      const value = (target.type && target.type === 'checkbox') ? target.checked : target.value;
      const name = target.name;
      let node =  JSON.parse(JSON.stringify(this.props.node));
      node.groups = [];
      _.set(node, name, value);
      this.props.updateNode(node, this.props.node)


     }
     
     addGroup() {        
            this.addItemToArray({"id":  RandomId(6),  "groupSlug": undefined, }, "groups", true)
     }

     
     

     

    render() {
        const {node} = this.props; 
        return (<div>
              <div className="panel message_panel">
                <InspectorNodeHeader title="SMSGroup" />
                <b>Action</b>
                <div className="radioButtons">
                <form>
                  <div className="radioItem">
                    <label className="inspectorLabel">
                      <input type="radio" name="action" value="add" onChange={this.changeAction} checked={node.action === "add"} />
                      <span className="radioText">Add</span>
                    </label>
                  </div>
                  <div className="radioItem">
                    <label className="inspectorLabel">
                      <input type="radio" name="action" value="remove" onChange={this.changeAction} checked={node.action === "remove"}/>
                      <span className="radioText">Remove</span>
                    </label>
                  </div>
                  </form>
                  </div>
            <b>Group</b>
            <SMSGroupSelect node={this.props.node} onChange={this.onChange} deleteGroup={this.deleteValue} /> 

            <div className="addElementButton" onClick={this.addGroup} >+ ADD GROUP</div>


              </div>
              <InspectorFooter deleteNode={this.deleteNode} node={this.props.node} />
            </div>);

     }
   }
}
export default SMSGroup;
